export default function PHP_sys_getloadavg() {
  return (
    <div>
      <h1>PHP_sys_getloadavg</h1>
    </div>
  );
}
